<template>
    <div
        v-show="showSearchContainer"
        class="search-container"
        :class="{
            'has-buttons': showFullScreen || showGpsTracker,
            'has-search': showSearch
        }"
    >
        <b-link
            v-show="showMenu"
            class="search-menu-icon"
            @click="$_onClickMenu"
            :title="getMenuTitle"
        >
            <span :class="getMenuIconClass"></span>
        </b-link>
        <template v-if="showSearch">
            <div v-if="showMenu" class="search-separator-icon"></div>
            <map-search
                :search-text="
                    menuBarComponents.mapControls.components.search.textToSearch
                "
                :search-suggestions="
                    menuBarComponents.mapControls.components.search.suggestions
                "
                :search-show-suggestions="
                    menuBarComponents.mapControls.components.search.showResults
                "
                mode="web"
                @open="openSearchResultFromMenuBar($event)"
                @reset="searchFromMenuBar({ searchText: undefined })"
                @updateDebounced="searchFromMenuBar({ searchText: $event })"
                @update="$_updateSearchText({ searchText: $event })"
                @focus="
                    togglePanel({
                        panelName: searchResultsPanelName,
                        visible: true
                    })
                "
            />
        </template>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS } from '../../../../constants';
    import SearchInput from './SearchInput.vue';

    export default {
        name: 'mobile-nav-bar',
        components: { 'map-search': SearchInput },
        data() {
            return {
                searchResultsPanelName: INTERFACE_PANEL_TRIGGERS.SEARCH_RESULTS
            };
        },
        computed: {
            ...mapState(['uiElements']),
            ...mapGetters(['getWebTheme', 'getWebThemeParameters', 'getMainMap']),
            menuBarComponents: function () {
                return this.uiElements.menuBar.components;
            },
            menuComponents: function () {
                return this.uiElements.menu.components;
            },
            showSearch() {
                return this.getWebTheme?.data?.showSearch;
            },
            showFullScreen() {
                return this.getWebTheme?.data?.showFullScreen;
            },
            showGpsTracker() {
                return (
                    this.getMainMap?.gpsTracker &&
                    this.getWebTheme?.data?.showGPSTracker
                );
            },
            showSearchContainer() {
                return this.getWebTheme && (this.showMenu || this.showSearch);
            },
            visibleMenuItems() {
                return Object.values(this.menuComponents).filter(
                    (item) => item.visible === true
                );
            },
            showMenu() {
                return this.visibleMenuItems.length >= 1;
            },
            getMenuIconClass() {
                return this.visibleMenuItems.length === 1
                    ? this.visibleMenuItems[0].icon
                    : 'navigation-icon';
            },
            getMenuTitle() {
                return this.visibleMenuItems.length === 1
                    ? this.$t(this.visibleMenuItems[0].title)
                    : this.$t('labelMenu');
            }
        },
        methods: {
            ...mapActions([
                'searchFromMenuBar',
                'openSearchResultFromMenuBar',
                'togglePanel'
            ]),
            $_onClickMenu() {
                if (this.visibleMenuItems.length === 1) {
                    if (this.menuComponents.legend.visible) {
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.LEGEND
                        });
                    } else if (this.menuComponents.filter.visible) {
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.FILTERS
                        });
                    } else if (this.menuComponents.measure.visible) {
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.MEASURE_EDIT
                        });
                    } else if (this.menuComponents.print.visible) {
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.PRINT
                        });
                    } else if (this.menuComponents.accessibility.visible) {
                        this.$router.push({
                            name: 'accessibleInfo',
                            params: {
                                tma:
                                    this.getWebThemeParameters?.guid ||
                                    this.getWebThemeParameters?.tma
                            }
                        });
                    } else {
                        this.togglePanel({
                            panelName: INTERFACE_PANEL_TRIGGERS.MENU
                        });
                    }
                } else {
                    this.togglePanel({ panelName: INTERFACE_PANEL_TRIGGERS.MENU });
                }
            },
            $_updateSearchText(searchText) {
                this.$store.commit('UPDATE_SEARCH_SEARCHTEXT', searchText);
            }
        }
    };
</script>

<style scoped lang="scss">
.search-container {
    @include z-index(web-search);
    position: absolute;
    top: 15px;
    left: 10px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #ced4da;
    transition: all 0.3s ease-in-out;

    &.has-search {
        width: 300px;
        height: initial;

        & .search-menu-icon {
            padding-left: 5px;
        }
    }

    & .search-menu-icon {
        flex: 0 0 30px;
        height: 30px;
        padding: 5px 0px 0px 4px;
        cursor: pointer;

        & span {
            display: block;
            width: 20px;
            height: 20px;
        }
    }

    & .search-separator-icon {
        border-left: 1px solid #b7b7b7;
        left: 35px;
        top: 6px;
        height: 24px;
    }
}

/*-------------------------------------
    max-width : 480px
    ---------------------------------------*/
@media (max-width: 480px) {
    .search-container {
        &.has-search {
            width: calc(100% - 20px);

            &.has-buttons {
                width: calc(100% - 70px);
            }
        }
    }
}
</style>
